export const getVideoForPiP = state => state.pip.video;
